import request from '@/utils/request'

// 列表
export function listMaterials(data) {
  return request({
    url: 'admin/data/mhmaterials/list',
    method: 'post',
    data
  })
}

// 添加列表
export function addListMaterials(id) {
  return request({
    url: 'admin/data/mhmaterials/listmhmaterials/'+id,
    method: 'get',
  })
}   

// 删除
export function delMaterials(data) {
  return request({
    url: 'admin/data/mhmaterials/delete',
    method: 'post',
    data
  })
}

// 新增
export function saveMaterials(data) {
  return request({
    url: 'admin/data/mhmaterials/save',
    method: 'post',
    data
  })
}